<script lang="ts">
  import { nextShortcode, prevShortcode } from "./stores";
  import { navigate } from "svelte-navigator";
  import { hideHelp, help } from "./stores";
  enum KeyCode {
    Left = "ArrowLeft",
    Right = "ArrowRight",
  }

  enum Key {
    QuestionMark = "?",
  }

  $: handleKeydown = ({ code, key }) => {
    if ($help) {
      hideHelp();
    } else if (key === Key.QuestionMark) {
      help.set(true);
    }

    if (code === KeyCode.Right && $nextShortcode) {
      navigate(`/art/${$nextShortcode}`);
    } else if (code === KeyCode.Left && $prevShortcode) {
      navigate(`/art/${$prevShortcode}`);
    }
  };
</script>

<svelte:window on:keydown={handleKeydown} />
